<template>
    <TV></TV>
</template>

<script>
import TV from "../../../components/ITDepartment/TV/TV.vue";
import AuthLayout from "../../../Layouts/AuthLayout.vue";

export default {
    name: "ITDepartment_TV",
    components: { TV, AuthLayout },
};
</script>
